/**
 * Designed by OnHOW YouTube Channel - Anas El Medlaoui
 */

const onhowStyles = `
  .onhow-tabs-container {
    margin-bottom: 0.3rem;
    width: 100%;
  }
  
  .onhow-tabs-nav {
    display: flex;
    border-bottom: 1px solid rgba(var(--color-foreground), 0.08);
    margin: 0;
    padding: 0;
    list-style: none;
  }
  
  .onhow-tabs-nav li {
    margin: 0;
    padding: 0;
  }
  
  .onhow-tab-button {
    position: relative;
    background: none;
    border: none;
    color: rgba(var(--color-foreground), 0.75);
    cursor: pointer;
    font-size: 1.15em;
    font-weight: 500;
    padding: 1rem 1.5rem;
    margin-right: 0.5rem;
  }
  
  .onhow-tab-button::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: transparent;
    transition: background-color 0.3s ease;
  }
  
  .onhow-tab-button.active {
    color: rgb(var(--color-base-accent-1));
    font-weight: 600;
  }
  
  .onhow-tab-button.active::after {
    background-color: rgb(var(--color-base-accent-1));
  }
  
  .onhow-tab-button:hover:not(.active) {
    color: rgb(var(--color-foreground));
  }
  
  .onhow-tab-content {
    display: none;
    padding: 0.02rem 0;
  }
  
  .onhow-tab-content.active {
    display: block;
  }
  
  .onhow-tab-content p:first-child {
    margin-top: 0;
  }
  
  @media screen and (max-width: 749px) {
    .onhow-tabs-nav {
      flex-wrap: wrap;
    }
    
    .onhow-tab-button {
      padding: 0.75rem 1rem;
      font-size: 1em;
    }
  }
`;

function addStyles(stylesText) {
  const styleElement = document.createElement('style');
  styleElement.textContent = stylesText;
  document.head.appendChild(styleElement);
}

class OnhowDescriptionTabs {
  constructor() {
    this.descriptionContainer = document.querySelector('rte-formatter');
    if (!this.descriptionContainer) return;
    
    addStyles(onhowStyles);
    
    this.init();
  }

  init() {
    const originalContent = this.descriptionContainer.cloneNode(true);
    
    const tabSections = this.findTabSections(originalContent);
    
    if (tabSections.length > 0) {
      this.createTabs(tabSections);
      
      this.hideOriginalTabSections();
    }
  }
  
  findTabSections(container) {
    const sections = [];
    const h3Elements = container.querySelectorAll('h3');
    
    h3Elements.forEach(h3 => {
      const text = h3.textContent.trim();
      const tabMatch = text.match(/^TAB(\d+):\s*(.*)/);
      
      if (tabMatch) {
        const tabNumber = parseInt(tabMatch[1]);
        const tabTitle = tabMatch[2].trim();
        
        const originalH3 = this.descriptionContainer.querySelector(`h3:nth-of-type(${Array.from(container.querySelectorAll('h3')).indexOf(h3) + 1})`);
        
        const content = this.getContentUntilDelimiter(originalH3);
        
        sections.push({
          number: tabNumber,
          title: tabTitle,
          content: content.html,
          originalElements: [originalH3, ...content.elements]
        });
      }
    });
    
    return sections.sort((a, b) => a.number - b.number);
  }
  
  /**
 * Designed by OnHOW YouTube Channel - Anas El Medlaoui
 */
  
  getContentUntilDelimiter(h3Element) {
    const contentElements = [];
    const contentHtml = [];
    let currentElement = h3Element.nextElementSibling;
    
    while (currentElement) {
      const elementHtml = currentElement.outerHTML;
      const elementText = currentElement.textContent;
      
      if (elementText.includes('$')) {
        const parts = elementHtml.split('$');
        contentHtml.push(parts[0]);
        contentElements.push(currentElement);
        break;
      } else {
        contentHtml.push(elementHtml);
        contentElements.push(currentElement);
        currentElement = currentElement.nextElementSibling;
      }
    }
    
    return {
      html: contentHtml.join(''),
      elements: contentElements
    };
  }
  
  createTabs(tabSections) {

    const tabsContainer = document.createElement('div');
    tabsContainer.className = 'onhow-tabs-container';
    
    const tabNav = document.createElement('ul');
    tabNav.className = 'onhow-tabs-nav';
    tabNav.setAttribute('role', 'tablist');
    
    const tabContentContainer = document.createElement('div');
    tabContentContainer.className = 'onhow-tabs-content-container';
    
    tabSections.forEach((section, index) => {
      const isActive = index === 0;
      
      const tabItem = document.createElement('li');
      tabItem.setAttribute('role', 'presentation');
      
      const tabButton = document.createElement('button');
      tabButton.className = `onhow-tab-button ${isActive ? 'active' : ''}`;
      tabButton.setAttribute('data-tab', `tab-${section.number}`);
      tabButton.setAttribute('id', `tab-button-${section.number}`);
      tabButton.setAttribute('aria-controls', `tab-${section.number}`);
      tabButton.textContent = section.title;
      
      tabItem.appendChild(tabButton);
      tabNav.appendChild(tabItem);
      
      const tabContent = document.createElement('div');
      tabContent.className = `onhow-tab-content ${isActive ? 'active' : ''}`;
      tabContent.setAttribute('role', 'tabpanel');
      tabContent.setAttribute('aria-labelledby', `tab-button-${section.number}`);
      tabContent.id = `tab-${section.number}`;
      
      let processedContent = section.content.replace(/\$/g, '');
      tabContent.innerHTML = processedContent;
      
      tabContentContainer.appendChild(tabContent);
    });
    
    tabsContainer.appendChild(tabNav);
    tabsContainer.appendChild(tabContentContainer);
    
    this.descriptionContainer.insertBefore(tabsContainer, this.descriptionContainer.firstChild);
    
    this.initializeTabs(tabsContainer);
  }
  
  hideOriginalTabSections() {
    const h3Elements = this.descriptionContainer.querySelectorAll('h3');
    
    h3Elements.forEach(h3 => {
      const text = h3.textContent.trim();
      const tabMatch = text.match(/^TAB(\d+):/);
      
      if (tabMatch) {
        h3.style.display = 'none';
        
        let currentElement = h3.nextElementSibling;
        
        while (currentElement) {
       
          if (currentElement.tagName === 'H3' || currentElement.textContent.includes('$')) {
            if (currentElement.textContent.includes('$')) {
              currentElement.style.display = 'none';
            }
            break;
          }
          
          currentElement.style.display = 'none';
          currentElement = currentElement.nextElementSibling;
        }
      }
    });
  }
  
  initializeTabs(tabsContainer) {
    const tabButtons = tabsContainer.querySelectorAll('.onhow-tab-button');
    const tabContents = tabsContainer.querySelectorAll('.onhow-tab-content');
    
    const setActiveTab = (targetButton) => {
      tabButtons.forEach(btn => {
        btn.classList.remove('active');
        btn.setAttribute('aria-selected', 'false');
      });
      
      targetButton.classList.add('active');
      targetButton.setAttribute('aria-selected', 'true');
      
      tabContents.forEach(content => {
        content.classList.remove('active');
      });
      
      const tabId = targetButton.getAttribute('data-tab');
      const targetContent = document.getElementById(tabId);
      if (targetContent) {
        targetContent.classList.add('active');
      }
    };
    
    tabButtons.forEach(button => {
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', button.classList.contains('active') ? 'true' : 'false');
      
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (this.classList.contains('active')) return;
        
        setActiveTab(this);
      });
    });
  }
}

(function() {
  function initTabs() {
    if (document.querySelector('rte-formatter')) {
      new OnhowDescriptionTabs();
    } else if (document.readyState !== 'complete') {
     
      setTimeout(initTabs, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs);
  } else {
    initTabs();
  }
})();